import {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import InputGroup from "react-bootstrap/InputGroup";
// -
import ModalGroup from "site-apps/assets/ModalGroup";
import ModalIslandSelect from "site-apps/distribution/island/ModalIslandSelect";
import ModalZonesSelect from "site-apps/distribution/zones/ModalZones";
import ModalRoutesStaticSelect from "site-apps/distribution/route/ModalRoutesStaticSelect";
import ModalAssetsSelectSimple from "site-apps/assets/components/ModalAssetsSelectSimple";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import {ContainerSVG} from "components/waste-icons/svgs/ContainerSVG";
import TagsInDiv from "components/TagsInDiv";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import {useTranslation} from "react-i18next";

const FiltersModel = {
    download_type: "",
    waste_type: "",
    groups: [],
    islands: [],
    routes: [],
    zones: [],
    uuids: [],
};

const TabFiltersFilters = ({
    formData,
    setFormData,
    icon,
    setIcon,
    setActiveNext,
    stepsTabs,
    editing,
}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _tT} = useTranslation("tags");
    const [filters, setFilters] = useState({...FiltersModel});
    const [groups, setGroups] = useState([]);
    const [islands, setIslands] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [zones, setZones] = useState([]);
    const [uuids, setUuids] = useState([]);
    const [showModalGroup, setShowModalGroup] = useState(false);
    const [showModalIsland, setShowModalIsland] = useState(false);
    const [showModalRoutes, setShowModalRoutes] = useState(false);
    const [showModalZones, setShowModalZones] = useState(false);
    const [showModalUuis, setShowModalUuis] = useState(false);
    const [activeSearchers, setActiveSearchers] = useState(false);
    const optimize = formData.params.optimize !== false;

    useEffect(() => {
        if (editing.data.filters) {
            let icon_ = {...icon};
            icon_.icon = <ContainerSVG type={formData.filters.waste_type} />;
            icon_.name = _Tc("wastes." + formData.filters.waste_type);
            icon_.download = _Tc("downloads." + formData.filters.download_type);
            setIcon(icon_);
        }
    }, [editing.data.filters]);

    useEffect(() => {
        setFilters({...formData.filters});
        setGroups([...formData.filters.groups]);
        setIslands([...formData.filters.islands]);
        setRoutes([...formData.filters.routes]);
        setZones([...formData.filters.zones]);
        setUuids([...formData.filters.uuids]);
        setActiveSearchers(
            formData.filters.waste_type && formData.filters.download_type
        );

        return () => {
            unsubscribeEvent("groupasset:modalselect:change", eventChangeGroup);
            unsubscribeEvent("island:modalselect:change", eventChangeIsland);
            unsubscribeEvent("routestatic:modalselect:change", eventChangeRoutes);
            unsubscribeEvent("zones:modalselect:change", eventChangeZones);
            unsubscribeEvent("assetsimple:modalselect:change", eventChangeUuids);
        };
    }, [formData.filters]);

    const disableNextTabs = () => {
        let active = stepsTabs.getCurrentSteps();
        if (active.criteria) {
            stepsTabs.disableTab("criteria");
            stepsTabs.disableTab("preview");
            stepsTabs.setAddAssets(false);
            stepsTabs.setFiltersDynamic(false);
            stepsTabs.setClassifyAssets(false);
        }
        setActiveNext(false);
    };

    useEffect(() => {
        let data = {...formData};
        data.filters.groups = [...groups];
        setFormData(data);
        disableNextTabs();
    }, [groups]);

    const onSelectGroup = (e) => {
        setShowModalGroup(true);
        subscribeEvent("groupasset:modalselect:change", eventChangeGroup);
    };
    const eventChangeGroup = (e) => {
        let groups_ = [...e.detail];
        setGroups(groups_);
        unsubscribeEvent("groupasset:modalselect:change", eventChangeGroup);
        setActiveNext(false);
    };
    // -
    useEffect(() => {
        let data = {...formData};
        data.filters.islands = [...islands];
        setFormData(data);
        disableNextTabs();
    }, [islands]);
    const onSelectIsland = (e) => {
        setShowModalIsland(true);
        subscribeEvent("island:modalselect:change", eventChangeIsland);
    };
    const eventChangeIsland = (e) => {
        let islands_ = [...e.detail];
        setIslands(islands_);
        unsubscribeEvent("island:modalselect:change", eventChangeIsland);
        setActiveNext(false);
    };
    // -
    useEffect(() => {
        let data = {...formData};
        data.filters.routes = [...routes];
        setFormData(data);
        disableNextTabs();
    }, [routes]);
    const onSelectRoutes = (e) => {
        setShowModalRoutes(true);
        subscribeEvent("routestatic:modalselect:change", eventChangeRoutes);
    };
    const eventChangeRoutes = (e) => {
        let routes_ = [...e.detail];
        setRoutes(routes_);
        unsubscribeEvent("routestatic:modalselect:change", eventChangeRoutes);
        setActiveNext(false);
    };
    // -
    useEffect(() => {
        let data = {...formData};
        data.filters.zones = [...zones];
        setFormData(data);
        disableNextTabs();
    }, [zones]);
    const onSelectZones = (e) => {
        setShowModalZones(true);
        subscribeEvent("zones:modalselect:change", eventChangeZones);
    };
    const eventChangeZones = (e) => {
        let zones_ = [...e.detail];
        setZones(zones_);
        unsubscribeEvent("zones:modalselect:change", eventChangeZones);
        setActiveNext(false);
    };
    // -
    useEffect(() => {
        let data = {...formData};
        data.filters.uuids = [...uuids];
        setFormData(data);
    }, [uuids]);
    // Sin optimizar solo cuentan los contenedores de la ruta estática: fuera los elegidos a mano
    useEffect(() => {
        if (!optimize && uuids.length) {
            setUuids([]);
            setActiveNext(false);
        }
    }, [optimize, uuids]);
    const onSelectUuids = (e) => {
        setShowModalUuis(true);
        subscribeEvent("assetsimple:modalselect:change", eventChangeUuids);
    };
    const eventChangeUuids = (e) => {
        let uuids_ = [];
        e.detail.forEach((_item) => {
            _item.name = _item.uid;
            uuids_.push(_item);
        });
        setUuids(uuids_);
        unsubscribeEvent("assetsimple:modalselect:change", eventChangeUuids);
        setActiveNext(false);
    };
    // -
    const handleSelects = (e) => {
        let {name, value} = e.target;
        updateFilters(name, value);
        disableNextTabs();
    };

    const updateFilters = (name, value) => {
        let data = {...filters};
        data[name] = value;
        setFilters(data);
        setFormData({...formData, filters: {...data}});

        if (name === "waste_type") {
            let icon_ = {...icon};
            if (value) {
                icon_.icon = <ContainerSVG type={value} />;
                icon_.name = _Tc("wastes." + value);
            } else {
                icon_.icon = <FontAwesomeIcon icon="question" size="3x" />;
                icon_.name = "";
            }
            setIcon(icon_);
        } else if (name === "download_type") {
            let icon_ = {...icon};
            icon_.download = value ? _Tc("downloads." + value) : "";
            setIcon(icon_);
        }

        setActiveSearchers(data.waste_type && data.download_type);
        setActiveNext(false);
    };

    return (
        <div className="row p-4">
            <div className="col-12">
                <div className="row">
                    <div className="col">
                        <label>{_tT("common.fraction")}*</label>
                        <WasteTypesSelect
                            value={filters.waste_type}
                            onChange={handleSelects}
                        />
                    </div>
                    {formData.filters.waste_type ? (
                        <div
                            className="col d-flex justify-content-center align-items-center"
                            style={{maxWidth: "100px"}}>
                            <ContainerSVG type={filters.waste_type} />
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <div className="col-12 mt-3">
                <label>{_tT("common.download")}*</label>
                <DownloadTypesSelect
                    value={filters.download_type}
                    onChange={handleSelects}
                />
            </div>
            <div className="col-12 mt-3">
                <label className="strong">Grupos</label>
                <InputGroup>
                    <TagsInDiv values={groups} setValues={setGroups} />
                    <Button
                        variant="outline-secondary"
                        onClick={onSelectGroup}
                        disabled={!activeSearchers}>
                        <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                    </Button>
                </InputGroup>
            </div>
            <div className="col-12 mt-3">
                <label className="strong">Islas</label>
                <InputGroup>
                    <TagsInDiv values={islands} setValues={setIslands} />
                    <Button
                        variant="outline-secondary"
                        onClick={onSelectIsland}
                        disabled={!activeSearchers}>
                        <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                    </Button>
                </InputGroup>
            </div>
            <div className="col-12 mt-3">
                <label className="strong">Rutas Estaticas</label>
                <InputGroup>
                    <TagsInDiv values={routes} setValues={setRoutes} />
                    <Button
                        variant="outline-secondary"
                        onClick={onSelectRoutes}
                        disabled={!activeSearchers}>
                        <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                    </Button>
                </InputGroup>
            </div>
            <div className="col-12 mt-3">
                <label className="strong">Zonas</label>
                <InputGroup>
                    <TagsInDiv values={zones} setValues={setZones} />
                    <Button
                        variant="outline-secondary"
                        onClick={onSelectZones}
                        disabled={!activeSearchers}>
                        <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                    </Button>
                </InputGroup>
            </div>
            <div className="col-12 mt-3">
                <label className="strong">UUIDs</label>
                <InputGroup>
                    <TagsInDiv values={uuids} setValues={setUuids} />
                    <Button
                        variant="outline-secondary"
                        onClick={onSelectUuids}
                        disabled={!activeSearchers || !optimize}>
                        <FontAwesomeIcon icon="fa-solid fa-plus" />
                    </Button>
                </InputGroup>
            </div>
            {showModalGroup ? (
                <ModalGroup
                    showModalGroup={showModalGroup}
                    setShowModalGroup={setShowModalGroup}
                    multiple={true}
                    create={false}
                    chosenIn={groups}
                    subtitle={document.title}
                />
            ) : (
                <></>
            )}
            {showModalIsland ? (
                <ModalIslandSelect
                    showModalIsland={showModalIsland}
                    setShowModalIsland={setShowModalIsland}
                    multiple={true}
                    create={false}
                    chosenIn={islands}
                    subtitle={document.title}
                />
            ) : (
                <></>
            )}
            {showModalRoutes ? (
                <ModalRoutesStaticSelect
                    show={showModalRoutes}
                    setShow={setShowModalRoutes}
                    multiple={true}
                    chosenIn={routes}
                    subtitle={document.title}
                />
            ) : (
                <></>
            )}
            {showModalZones ? (
                <ModalZonesSelect
                    show={showModalZones}
                    setShow={setShowModalZones}
                    multiple={true}
                    chosenIn={zones}
                    subtitle={document.title}
                />
            ) : (
                <></>
            )}
            {showModalUuis ? (
                <ModalAssetsSelectSimple
                    show={showModalUuis}
                    setShow={setShowModalUuis}
                    multiple={true}
                    chosenIn={uuids}
                    subtitle={document.title}
                    filtering={{
                        waste_type: filters.waste_type,
                        download_type: filters.download_type,
                    }}
                />
            ) : (
                <></>
            )}
        </div>
    );
};
export default TabFiltersFilters;
